import moment from 'moment'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import _ from 'lodash'

import i18n from '@/i18n'

/**
 *  Format the phone into international string format for easier reading.
 **/
function formatToPhoneString (phone) {
  // TODO: Hardcoded for Hong Kong, ref: https://gitlab.com/blocksq/authcore/issues/14
  if (phone !== undefined) {
    const phoneNumber = parsePhoneNumberFromString(phone, 'HK')
    if (phoneNumber !== undefined) {
      return phoneNumber.formatInternational()
    }
  }
  return phone
}

export function marshalDatetime (datetime, format) {
  return moment(datetime).format(format)
}

export function marshalContact (contact) {
  function getType (type) {
    switch (type) {
      case undefined: return 'email'
      case 'EMAIL': return 'email'
      case 'PHONE': return 'phone'
      default: throw new Error(`undefined type ${type}`)
    }
  }
  let valueString = contact.value
  if (contact.type === 'PHONE') {
    valueString = formatToPhoneString(contact.value)
  }
  return {
    id: parseInt(contact.id, 10),
    type: getType(contact.type),
    value: valueString,
    isPrimary: contact.primary,
    isVerified: contact.verified || false
  }
}

export function marshalAuditLog (auditLog) {
  function getResult (type) {
    switch (type) {
      case undefined: return 'unknown'
      case 'FAIL': return 'fail'
      case 'SUCCESS': return 'success'
      default: throw new Error(`undefined result ${type}`)
    }
  }
  return {
    id: parseInt(auditLog.id, 10),
    username: auditLog.username,
    action: i18n.t(auditLog.action),
    target: auditLog.target,
    sessionId: auditLog.session_id,
    device: auditLog.device,
    ip: auditLog.ip,
    description: auditLog.description,
    result: getResult(auditLog.result),
    isInternal: auditLog.is_internal,
    createdAt: moment(auditLog.created_at).format('HH:mm:ss, DD MMM Y')
  }
}

export function marshalPermission (permission) {
  return {
    name: permission.name
  }
}

export function marshalRole (role) {
  const beautifyName = roleName => _.startCase(_.last(roleName.split('.')))
  return {
    id: parseInt(role.id, 10),
    name: role.system_role === true ? beautifyName(role.name) : role.name,
    isSystemRole: role.system_role === true
  }
}

export function marshalMFA (device) {
  // Default to be not set, only SMS device has relevant value
  let valueString = '-'
  if (device.type === 'sms' && device.value !== '-') {
    valueString = formatToPhoneString(device.value)
  }
  let lastUsedAt = '-'
  let createdAt = '-'
  if (device.last_used_at !== '') {
    createdAt = moment(device.last_used_at).format('DD MMM Y, HH:mm')
  }
  if (device.last_used_at !== '') {
    lastUsedAt = moment(device.last_used_at).format('DD MMM Y, HH:mm')
  }
  return {
    type: device.type,
    value: valueString,
    createdAt: createdAt,
    lastUsedAt: lastUsedAt
  }
}

export function marshalUser (user) {
  let profileName
  if (user.display_name !== undefined) {
    profileName = user.display_name
  } else if (user.username !== undefined) {
    profileName = user.username
  } else if (user.email !== undefined) {
    profileName = user.email
  } else if (user.phone !== undefined) {
    profileName = user.phone
  } else {
    profileName = 'No data shown'
  }
  return {
    id: parseInt(user.id, 10),
    profileName: profileName,
    username: user.username,
    primaryEmail: user.primary_email,
    primaryEmailVerified: user.primary_email_verified,
    primaryPhone: formatToPhoneString(user.primary_phone),
    primaryPhoneVerified: user.primary_phone_verified,
    displayName: user.display_name,
    smsAuthentication: user.sms_authentication || false,
    totpAuthentication: user.totp_authentication || false,
    locked: user.locked,
    createdAt: moment(user.created_at).format('DD MMM Y, LT')
  }
}

export function marshalOAuthFactor (oauthFactor) {
  let service = oauthFactor.service || 'FACEBOOK'
  service = service.charAt(0) + service.slice(1).toLowerCase()
  return {
    id: parseInt(oauthFactor.id, 10),
    userId: parseInt(oauthFactor.user_id, 10),
    service: service,
    oauthUserId: oauthFactor.oauth_user_id,
    createdAt: oauthFactor.created_at === '' ? '' : marshalDatetime(oauthFactor.created_at, 'YYYY-MM-DD HH:mm'),
    lastUsedAt: oauthFactor.last_used_at === '' ? '' : marshalDatetime(oauthFactor.last_used_at, 'YYYY-MM-DD HH:mm')
  }
}

export function marshalSession (session) {
  let lastSeenAt = ''
  let expiredAt = ''
  if (session.last_seen_at !== '0001-01-01T00:00:00Z') {
    lastSeenAt = moment(session.last_seen_at).format('HH:mm:ss, DD MMM Y')
  }
  if (session.expired_at !== '0001-01-01T00:00:00Z') {
    expiredAt = moment(session.expired_at).format('HH:mm:ss, DD MMM Y')
  }
  return {
    id: parseInt(session.id, 10),
    userAgent: session.user_agent,
    lastSeenAt: lastSeenAt,
    lastSeenIp: session.last_seen_ip,
    lastSeenLocation: session.last_seen_location,
    expiredAt: expiredAt
  }
}

export function marshalTemplate (template) {
  let updatedAt = ''
  if (template.updated_at) {
    updatedAt = marshalDatetime(template.updated_at, 'YYYY-MM-DD HH:mm')
  }
  return {
    language: template.language,
    name: template.name,
    updatedAt: updatedAt
  }
}
